@if(useMap){
<!-- Start::input de búsqueda en mapa -->
<!--<pre style="background-color: pink">
  searchField: {{ searchField.errors | json }}
 </pre
>-->
<div class="field mb-4 flex flex-column">
  <label class="font-semibold text-900">Ingresa tu dirección completa</label>
  <app-address-input
    (onChangeAddress)="setAddress($event)"
    formControlName="search"
  />
</div>
<app-map-v2 (mapDragend)="onDragEnd($event)" />
<!-- End::input de búsqueda en mapa -->
}
<!--
<pre style="background-color: yellow">
  {{ parentForm.value | json }}
</pre>-->

<!-- Start::input de calle -->
<div class="field mb-4 flex flex-column">
  <label for="street" class="font-semibold text-900">Calle</label>
  <input
    id="street"
    type="text"
    pInputText
    spellcheck="false"
    formControlName="street"
    (blur)="setAddressManually()"
  />
</div>
<!-- End::input de calle -->

<!-- Start::input de número -->
<div class="field mb-4 flex flex-column">
  <label for="number" class="font-semibold text-900">Número</label>
  <app-number-input
    id="number"
    formControlName="number"
    (blur)="setAddressManually()"
  />
</div>
<!-- End::input de número -->

@if(countryCode === 'cl'){
<!-- Start::inputs para Chile -->
<!-- Start::input de comuna -->
<div class="field mb-4 flex flex-column">
  <label for="commune" class="font-semibold text-900">Comuna</label>
  <p-dropdown
    [options]="communes()"
    formControlName="commune"
    optionLabel="city"
    [filter]="true"
    filterBy="city"
    optionValue="id"
    placeholder="Selecciona una comuna"
    dropdownIcon="fa-sharp fa-solid fa-chevron-down"
    loadingIcon="fa-sharp fa-solid fa-spinner-third fa-spin"
    spellcheck="false"
    [loading]="isLoadingCommunes()"
    (onBlur)="onSelectCommune()"
  />
</div>
<!-- End::input de comuna -->

<!-- End::input de localidad -->
<!-- End::inputs para Chile -->
} @else if(countryCode === 'pe'){
<!-- Start::inputs para Perú -->
<!-- Start::input de departamento -->
<div class="field mb-4 flex flex-column">
  <label for="region" class="font-semibold text-900">Departamento</label>
  <p-dropdown
    [options]="departamentos()"
    formControlName="region"
    optionLabel="nombre"
    [filter]="true"
    filterBy="nombre"
    optionValue="nombre"
    placeholder="Selecciona un departamento"
    dropdownIcon="fa-sharp fa-solid fa-chevron-down"
    loadingIcon="fa-sharp fa-solid fa-spinner-third fa-spin"
    spellcheck="false"
    [loading]="isLoadingDepartamentos()"
    (onBlur)="setDepartamentoManually()"
    (onChange)="onSelectDepartamento($event)"
    emptyMessage="No se encontraron departamentos"
    emptyFilterMessage="No se encontraron departamentos"
  />
</div>
<!-- End::input de departamento -->

<!-- Start::input de provincia -->
<div class="field mb-4 flex flex-column">
  <label for="commune" class="font-semibold text-900">Provincia</label>
  <p-dropdown
    [options]="provincias()"
    formControlName="commune"
    optionLabel="nombre"
    [filter]="true"
    filterBy="nombre"
    optionValue="nombre"
    placeholder="Selecciona una provincia"
    dropdownIcon="fa-sharp fa-solid fa-chevron-down"
    loadingIcon="fa-sharp fa-solid fa-spinner-third fa-spin"
    spellcheck="false"
    [loading]="isLoadingProvincias()"
    (onChange)="onSelectProvincia($event)"
    emptyMessage="No se encontraron provincias"
    emptyFilterMessage="No se encontraron provincias"
  />
</div>
<!-- End::input de provincia -->

<!-- Start::input de distrito -->
<div class="field mb-4 flex flex-column">
  <label for="commune" class="font-semibold text-900">Distrito</label>
  <p-dropdown
    [options]="distritos()"
    formControlName="locality"
    optionLabel="nombre"
    [filter]="true"
    filterBy="nombre"
    optionValue="codigo"
    placeholder="Selecciona una provincia"
    dropdownIcon="fa-sharp fa-solid fa-chevron-down"
    loadingIcon="fa-sharp fa-solid fa-spinner-third fa-spin"
    spellcheck="false"
    [loading]="isLoadingDistritos()"
    emptyMessage="No se encontraron distritos"
    emptyFilterMessage="No se encontraron distritos"
  />
</div>
<!-- End::input de provincia -->

<!-- End::inputs para Perú -->
} @else if(countryCode === 'es') {
<!-- Start::inputs para España -->

<!-- Provincia -->
<div class="field mb-4 flex flex-column">
  <label for="province" class="font-semibold text-900">Provincia</label>
  <input
    id="province"
    type="text"
    pInputText
    formControlName="region"
    (blur)="setAddressManually()"
  />
</div>

<!-- Localidad -->
<div class="field mb-4 flex flex-column">
  <label for="locality" class="font-semibold text-900">Localidad</label>
  <input
    id="locality"
    type="text"
    pInputText
    formControlName="locality"
    (blur)="setAddressManually()"
  />
</div>

<!-- Tipo de vía -->
<div class="field mb-4 flex flex-column">
  <label for="streetType" class="font-semibold text-900">Tipo de vía</label>
  <p-dropdown
    [options]="streetTypes"
    formControlName="streetType"
    optionLabel="label"
    optionValue="value"
    placeholder="Selecciona tipo de vía"
  ></p-dropdown>
</div>

<!-- Código postal -->
<div class="field mb-4 flex flex-column">
  <label for="postalCode" class="font-semibold text-900">Código Postal</label>
  <input
    id="postalCode"
    type="text"
    pInputText
    formControlName="postalCode"
    (blur)="setAddressManually()"
  />
</div>

<div class="mt-4 p-2 border-round border-1 surface-border">
  <div class="field">
    <label for="contactRut">NIF/NIE</label>
    <input
      id="contactRut"
      formControlName="contactDocumentId"
      pInputText
      placeholder="Ej: 12345678A"
      (blur)="onNifBlur()"
    />
  </div>
  <div class="field">
    <label for="nombre">Nombre</label>
    <input
      id="nombre"
      formControlName="contactName"
      pInputText
      placeholder="Ej: Juan"
    />
  </div>
  <div class="field">
    <label for="apellido">Apellido</label>
    <input
      id="apellido"
      formControlName="contactLastName"
      pInputText
      placeholder="Ej: Pérez"
    />
  </div>
  <div class="field">
    <label for="telefono">Teléfono</label>
    <input
      id="telefono"
      formControlName="contactPhone"
      pInputText
      placeholder="Ej: +34900111222"
      maxlength="9"
      (keypress)="soloNumeros($event)"
    />
  </div>
  <div class="field">
    <label for="email">Correo electrónico</label>
    <input
      id="email"
      type="email"
      formControlName="contactEmail"
      pInputText
      placeholder="ejemplo@correo.com"
    />
  </div>
</div>
<!-- End::inputs para España -->
}

<!-- Start::input de departamento u oficina -->
@if(isEnabledDepartmentInput){
<div class="field mb-4 flex flex-column">
  <label for="departmentOrHouse" class="font-semibold text-900" optional>
    Departamento / Oficina
  </label>
  <input
    spellcheck="false"
    id="departmentOrHouse"
    type="text"
    pInputText
    formControlName="departmentOrHouse"
  />
</div>
}
<!-- End::input de departamento u oficina -->

<!-- Start::input de referencia -->
<div class="field mb-5 flex flex-column">
  <label for="reference" class="font-semibold text-900" optional
    >Referencia</label
  >
  <textarea
    spellcheck="false"
    id="reference"
    formControlName="reference"
    pInputTextarea
    [autoResize]="true"
  ></textarea>
  @if(referenceHelperText){
  <small id="reference-help"> Ej: {{ referenceHelperText }} </small>
  }
</div>
<!-- End::input de referencia -->
